const TestimonialsSection = () => {
  const commitments = [
    {
      icon: "⚡",
      title: "Fast Response Time",
      description: "Quick quotes and immediate support",
      stat: "< 24 hours"
    },
    {
      icon: "🎯",
      title: "Custom Solutions", 
      description: "Tailored machinery recommendations",
      stat: "100% Custom"
    },
    {
      icon: "💰",
      title: "Competitive Pricing",
      description: "Best market prices",
      stat: "Best Value"
    },
    {
      icon: "🛡️",
      title: "Quality Assurance",
      description: "Rigorous quality checks",
      stat: "0 Compromise"
    },
    {
      icon: "🚚", 
      title: "Reliable Logistics",
      description: "Efficient shipping across India",
      stat: "Pan-India"
    },
    {
      icon: "🔧",
      title: "Expert Support",
      description: "Technical guidance & service",
      stat: "24/7 Support"
    }
  ];

  return (
    <section className="bg-gray-50 py-12 sm:py-16 px-4 sm:px-6" id="testimonials">
      <div className="max-w-6xl mx-auto">
        
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-white rounded-full px-4 py-2 mb-4 border border-gray-200">
            <div className="w-1.5 h-1.5 bg-[#00d9ff] rounded-full"></div>
            <span className="text-sm font-semibold text-[#002946]">WHY CHOOSE US</span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#002946] mb-4">
            Our <span className="text-[#00d9ff]">Commitment</span>
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-sm sm:text-base">
            Built on principles that guarantee your success
          </p>
        </div>

        {/* Commitments Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {commitments.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 shadow-lg border border-gray-100 hover:shadow-xl transition-shadow duration-300"
            >
              <div className="flex items-center justify-between mb-4">
                <div className="w-12 h-12 bg-gray-100 rounded-xl flex items-center justify-center">
                  <span className="text-xl">{item.icon}</span>
                </div>
                <div className="text-right">
                  <div className="text-lg font-bold text-[#002946]">{item.stat}</div>
                </div>
              </div>
              <h3 className="text-lg font-bold text-[#002946] mb-3">
                {item.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;